import {ValueDefinition} from '@/model/types';

export const enum Sex {
  MALE = 'DV-6#0',
  FEMALE = 'DV-6#1',
}

export const DV_6 = {
  id: 'DV-6',
  description: {
    fr: 'Sexe',
    en: 'Sex',
  },
  values: [
    {
      id: '0',
      value: {
        fr: 'Homme',
        en: 'Male',
      },
    },
    {
      id: '1',
      value: {
        fr: 'Femme',
        en: 'Female',
      },
    },
  ],
} as const satisfies ValueDefinition;
